import React, { useState, useEffect } from "react";
import { onMessageListener } from "middlewares/firebase";
import toast, { Toaster } from "react-hot-toast";

import useTheme from "hooks/useTheme";

import { getAccountNameByAccountID } from "actions/accounts";
import { getContactNameByAccountID } from "actions/contacts";

import CloseRoundIcon from "theme/icons/CloseRound";

const FirebaseNotifications = () => {
	const { themeColor } = useTheme();

	const [notification, setNotification] = useState({ title: "", message: "", txn: "" });

	let newNotificationMessage = null;
	let accountName = null;

	const setNotificationMessage = async () => {
		if (notification?.message.includes("received")) {
			accountName = await getContactNameByAccountID(notification?.txn?.snd ? notification.txn.snd : notification.txn.asnd);

			if (accountName) newNotificationMessage = notification?.message.replace(/\w{5}\.{3}\w{5}$/gi, accountName);
			else {
				accountName = await getAccountNameByAccountID(
					notification?.txn?.snd ? notification.txn.snd : notification.txn.asnd
				);

				if (accountName) newNotificationMessage = notification?.message.replace(/\w{5}\.{3}\w{5}$/gi, accountName);
			}
		} else if (notification?.message.includes("sent")) {
			accountName = await getContactNameByAccountID(notification?.txn?.rcv ? notification.txn.rcv : notification.txn.arcv);

			if (accountName) newNotificationMessage = notification?.message.replace(/\w{5}\.{3}\w{5}$/gi, accountName);
			else {
				accountName = await getAccountNameByAccountID(
					notification?.txn?.rcv ? notification.txn.rcv : notification.txn.arcv
				);

				if (accountName) newNotificationMessage = notification?.message.replace(/\w{5}\.{3}\w{5}$/gi, accountName);
			}
		}

		// } else if (notification?.message.includes("Optin")) {
		// 	const accountName = await getAccountNameByAccountID(
		// 		notification?.txn?.rcv ? notification.txn.rcv : notification.txn.arcv
		// 	);
		// 	if (accountName) newNotificationMessage = notification?.message.replace(/\w{5}\.{3}\w{5}$/gi, accountName);
	};

	const notify = async () => {
		await setNotificationMessage();

		return toast.custom(
			(t) => (
				<div
					className={`${
						t.visible ? "animate-enter" : "animate-leave"
					} relative max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto flex border border-opacity-40 ${
						themeColor?.border
					}`}
				>
					<div className="flex flex-col items-start p-3 space-y-1">
						<p className={`text-sm font-medium ${themeColor?.text}`}>{notification?.title}</p>

						<div className="flex w-full items-center justify-start space-x-2">
							<img
								className="h-4 w-4 rounded-full"
								src={`${process.env.REACT_APP_DAFFI_MAINNET_URL}/assets/image?assetID=${notification?.txn.xaid}&width=30&amount=30`}
								alt=""
							/>
							<p className={`text-sm ${themeColor?.text}`}>
								{newNotificationMessage ? newNotificationMessage : notification?.message}
							</p>
						</div>
					</div>
					<CloseRoundIcon
						onClick={() => toast.dismiss(t.id)}
						className={`w-4 absolute top-3 right-3 cursor-pointer`}
						fill={`${themeColor?.hex}`}
					/>
				</div>
			),
			{ duration: 10000 }
		);
	};

	useEffect(() => {
		if (notification?.message) notify();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [notification]);

	onMessageListener()
		.then((payload) => {
			setNotification({ title: "Transaction Alert", message: payload?.data?.message, txn: JSON.parse(payload?.data?.txn) });
		})
		.catch((err) => console.log("failed: ", err));

	return <Toaster position="bottom-left" reverseOrder={false} />;
};

export default FirebaseNotifications;
